import {DataSourceType} from 'common/src/modules/dataSources/dataSources.types';
import _includes from 'lodash/includes';

export default function isUserProfilingRelatedDataSourceType(type: DataSourceType) {
  return _includes([DataSourceType.AppEvents, DataSourceType.WebsitePixels], type);
}
